import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { commentedEventTypeMessages, createdEventTypeMessages, defaultEventTypeMessages, editedEventTypeMessages, publishedEventTypeMessages, updatedEventTypeMessages, viewedEventTypeMessages } from './messages';
export var LOCAL_EVENT_TYPE_MESSAGES = {
  commented: commentedEventTypeMessages,
  created: createdEventTypeMessages,
  edited: editedEventTypeMessages,
  published: publishedEventTypeMessages,
  updated: updatedEventTypeMessages,
  viewed: viewedEventTypeMessages
};
export function messageForEventType(eventType) {
  var eventTypeMessages = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : LOCAL_EVENT_TYPE_MESSAGES;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _options$isAbsolute = options.isAbsolute,
    isAbsolute = _options$isAbsolute === void 0 ? true : _options$isAbsolute,
    _options$isMyActivity = options.isMyActivityData,
    isMyActivityData = _options$isMyActivity === void 0 ? true : _options$isMyActivity,
    _options$isSimple = options.isSimple,
    isSimple = _options$isSimple === void 0 ? false : _options$isSimple;
  var eventTypeMessage = eventTypeMessages.hasOwnProperty(eventType) ? eventTypeMessages[eventType] : defaultEventTypeMessages;
  if (isSimple) {
    if (isMyActivityData) {
      return eventTypeMessage.standalone;
    } else {
      return eventTypeMessage.multiStandalone;
    }
  } else {
    if (isMyActivityData && isAbsolute) {
      return eventTypeMessage.absolute;
    } else if (isMyActivityData && !isAbsolute) {
      return eventTypeMessage.relative;
    } else if (!isMyActivityData && isAbsolute) {
      return eventTypeMessage.multiAbsolute;
    } else {
      return eventTypeMessage.multiRelative;
    }
  }
}
export function translatedStringsToMessageDescriptors(translatedStrings) {
  if (!translatedStrings) {
    return undefined;
  }
  return Object.entries(translatedStrings).reduce(function (acc, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      eventType = _ref2[0],
      translatedMessages = _ref2[1];
    acc[eventType] = Object.entries(translatedMessages).reduce(function (eventTypeMessages, _ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
        translatedKey = _ref4[0],
        translatedEntry = _ref4[1];
      eventTypeMessages[translatedKey] = {
        defaultMessage: translatedEntry,
        id: "recentWork.eventTypeMessage.translated.".concat(translatedKey, ".no-translate")
      };
      return eventTypeMessages;
    }, {});
    return acc;
  }, {});
}